import React from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { InputLabel, FormControlLabel, Checkbox } from "@material-ui/core";

const FormCheckbox = (props) => {
  let theme = useTheme();
  const classes = makeStyles({
    label: {
      textAlign: "center", 
      width: "133%", 
      position: "absolute"
    },
    checkboxWithLabel: {
      marginTop: 10
    }
  })(theme);

  const disabled = (props.readOnly || props.disabled)?{disabled:true}:{};
  const classNames = [props.className];
  if (props.readOnly) {
    classNames.push('readOnly');
  }
  if (props.label && props.labelPlacement !== "start" && props.labelPlacement !== "end") {
    classNames.push(classes.checkboxWithLabel);
  }
  const className = classNames.join(' ');

  if (props.labelPlacement === "start" || props.labelPlacement === "end")
    return (
      <FormControlLabel
        key={props.id}
        id={props.id}
        label={props.label}
        labelPlacement={props.labelPlacement||"top"}
        className={className}
        control={
          <Checkbox
            key={props.id}
            id={props.id}
            //className={classes.label}
            checked={props.checked?true:false}
            {...disabled}
            onChange={props.onChange}
          />
        }
        shrink="true"
        onChange={props.onChange}
        checked={props.checked?true:false}
      />
    );

  return (
    <div style={{position:"relative"}}>
      {props.label?
        <InputLabel className={classes.label} htmlFor={`${props.id}`} shrink id={`${props.id}-label`}>{props.label}</InputLabel>
        :<></>
      }
      <div style={{textAlign: "center"}}>
        <Checkbox 
          key={props.id}
          id={props.id} 
          className={className}
          checked={props.checked?true:false}
          {...disabled}
          onChange={props.onChange}
        />
      </div>
    </div>
  );
}

export default FormCheckbox;